'use client';

import { Button, Heading, Text, VStack } from '@jaaq/hub-ui';
import { logger } from '@jaaq/observability';
import { type ReactElement, useEffect } from 'react';

type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

const GlobalErrorPage = ({ error, unstable_retry }: GlobalErrorPageProps): ReactElement => {
  useEffect(() => {
    logger.error('app/global-error: root layout failed', { error, digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-screen bg-surface-inverse text-fg-inverse">
        <VStack align="center" justify="center" gap={4} className="min-h-screen p-8 text-center">
          <Heading level={1} variant="subtitle" tone="inverse">
            Something went wrong
          </Heading>
          <Text tone="inverse" muted className="max-w-md">
            JAAQ Hub hit an unexpected error. Refresh the page, or try again below.
          </Text>
          <Button variant="filled" size="regular" onClick={() => unstable_retry()}>
            Try again
          </Button>
        </VStack>
      </body>
    </html>
  );
};

export default GlobalErrorPage;
